import React, { useMemo } from 'react';
import styles from './Skeleton.module.css';
import { applyStyles } from '../../../utils/applyStyles';

interface SkeletonProps {
  width?: string;
  height?: string;
  mt?: string;
  mb?: string;
  className?: string;
}

const Skeleton: React.FC<SkeletonProps> = React.memo(({ className, width, height, mt: marginTop, mb: marginBottom }) => {
  return (
    <div style={{ width, height, marginTop, marginBottom }} className={applyStyles([styles['skeleton'], className ?? ''])} />
  );
});

export default Skeleton;
